<template>
  <div class="OptionStrategyCard">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="isDesktopExpertView">
        <el-card
          class="box-card"
          v-for="(reco_data, index) in recommendationsList"
          :key="index"
          :style="[
            (subscribedPlanDetails.plan == 'Lite' || !subscribedPlanDetails.plan) && index != 0 && $route.path == '/expert-past-strategy-options'
              ? {}
              : reco_data.strategy.risk_tag == 'Low Risk'
              ? { boxShadow: '7px 0px 0px -1px #0BA042' } // box-shadow for low_risk
              : reco_data.strategy.risk_tag == 'Moderate Risk'
              ? { boxShadow: '7px 0px 0px -1px #FFB800' } // box-shadow for moderate_risk
              : reco_data.strategy.risk_tag == 'High Risk'
              ? { boxShadow: '7px 0px 0px -1px #EA2526' } // Box-shadow for high_risk
              : { boxShadow: '7px 0px 0px -1px #FFB800' }, // Default box-shadow for moderate_risk
          ]"
        >
          <div v-loading="reco_data.is_strategy_loading" style="position: relative">
            <div
              :style="[
                index != 0 && $route.path == '/expert-past-strategy-options' && (subscribedPlanDetails.plan == 'Lite' || !subscribedPlanDetails.plan)
                  ? {
                      cursor: 'pointer',
                      pointerEvents: 'none',
                      minHeight: '350px',
                    }
                  : 'pointer',
              ]"
            >
              <!-- {{reco_data}} -->
              <div style="display: flex; justify-content: space-between">
                <div class="flex flex-space-between" style="width: 100%; align-items: flex-start">
                  <div>
                    <span class="stock-title cursor-pointer" v-if="reco_data.data.length == 1">
                      {{ reco_data.data[0].stock.title }}
                      {{ moment(reco_data.data[0].stock.expiry).format('D MMM YY' + "'") }}
                      {{ reco_data.data[0].stock.strike }}
                      {{ reco_data.data[0].stock.instrument_type }}
                    </span>
                    <span class="stock-title cursor-pointer" v-else>
                      {{ reco_data.strategy.title ? reco_data.strategy.title : '' }}
                      {{ reco_data.strategy.expiry ? moment(reco_data.strategy.expiry).format('DD MMM YYYY') : '' }}
                      <el-popover placement="bottom" trigger="click" style="position: relative; bottom: 4px">
                        <div style="margin: 0">
                          <div>
                            <div style="border-bottom: 1px solid #ddd; padding-bottom: 5px">
                              <div class="input-label-bold-gray">Description</div>

                              <div class="font-08rem" style="color: #000">
                                {{ reco_data.logic.length ? reco_data.logic[0].discription : '' }}
                              </div>
                            </div>

                            <div style="border-bottom: 1px solid #ddd; padding-bottom: 15px; margin-bottom: 15px">
                              <div class="input-label-bold-gray">Tags</div>
                              <div class="flex flex-wrap">
                                <div class="font-08rem" style="margin: 7px 5px" v-for="(subTags, tag_index) in reco_data.strategy.sub_tags" :key="tag_index">
                                  <span class="sub-tags">{{ subTags }}</span>
                                </div>
                              </div>
                            </div>

                            <div v-if="reco_data.logic[0]">
                              <div class="flex-space-between bottom-margin-5" v-for="(media, media_index) in reco_data.logic[0].mediaArray" :key="media_index">
                                <div class="input-label" style="font-size: 0.7rem">Attachment {{ media_index + 1 }}</div>

                                <div class="font-08rem primary-theme-color cursor-pointer" @click="downloadAttachment(media)">
                                  <i class="el-icon-download"></i>
                                  Download
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <img class="info-Logo cursor-pointer" src="../assets/images/Logic.svg" alt="" slot="reference" />
                      </el-popover>
                    </span>
                    &nbsp;
                    <div v-if="reco_data.data.length == 1">
                      <div>
                        <span class="estimate-value right-margin-10" title="Current price">
                          ₹
                          {{ reco_data.data[0].stock.ltp }}
                        </span>

                        <span class="top-margin-10 stock-section-inc" :style="[reco_data.data[0].stock.price_change_in_rs >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
                          <span style="font-size: 18px" v-if="reco_data.data[0].stock.price_change_in_rs >= 0">&#9652;</span>
                          <span style="font-size: 18px" v-else>&#9662;</span>
                          {{ reco_data.data[0].stock.price_change_in_rs }}({{ reco_data.data[0].stock.price_change_in_percentage }}%)
                        </span>
                        <el-popover placement="bottom" trigger="click" style="position: relative; bottom: 4px">
                          <div style="margin: 0">
                            <div>
                              <div style="border-bottom: 1px solid #ddd; padding-bottom: 5px">
                                <div class="input-label-bold-gray">Description</div>

                                <div class="font-08rem" style="color: #000">
                                  {{ reco_data.logic.length ? reco_data.logic[0].discription : '' }}
                                </div>
                              </div>

                              <div style="border-bottom: 1px solid #ddd; padding-bottom: 15px; margin-bottom: 15px">
                                <div class="input-label-bold-gray">Tags</div>
                                <div class="flex flex-wrap">
                                  <div class="font-08rem" style="margin: 7px 5px" v-for="(subTags, tag_index) in reco_data.strategy.sub_tags" :key="tag_index">
                                    <span class="sub-tags">{{ subTags }}</span>
                                  </div>
                                </div>
                              </div>

                              <div v-if="reco_data.logic[0]">
                                <div class="flex-space-between bottom-margin-5" v-for="(media, media_index) in reco_data.logic[0].mediaArray" :key="media_index">
                                  <div class="input-label" style="font-size: 0.7rem">Attachment {{ media_index + 1 }}</div>

                                  <div class="font-08rem primary-theme-color cursor-pointer" @click="downloadAttachment(media)">
                                    <i class="el-icon-download"></i>
                                    Download
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <img class="info-Logo cursor-pointer" src="../assets/images/Logic.svg" alt="" slot="reference" />
                        </el-popover>
                      </div>
                      <div class="input-label-gray" style="font-size: 10px">
                        <!-- Aug 22, 2023, 05:20 PM IST -->
                        {{ reco_data.data[0].stock.last_traded_timestamp | stock_live_price_date_filter }}
                      </div>
                    </div>
                  </div>

                  <div class="reco-date-mobile text-right">
                    <label class="input-label-gray flex-end" style="font-size: 11px">
                      Strategy Date :
                      {{ reco_data.strategy.created_date | stock_live_price_date_filter }}

                      <span style="position: relative; top: 2px; left: 4px" v-if="currentComponent != 'PastStrategyOptions'">
                        <el-popover v-if="userProfile.extra_info && userProfile.extra_info.can_copy_reco_data" placement="bottom" trigger="click" style="margin-bottom: 4px">
                          <div style="width: 170px !important">
                            <div class="flex" v-if="!reco_data.is_reco_subscribe_for_notification">
                              <img src="../assets/images/ribbon.png" alt="" style="width: 18px; margin-right: 10px" class="left-margin-5 cursor-pointer" v-on:click="followReco(reco_data.strategy.id, index, 'FOLLOW')" />
                              Add to watchlist
                            </div>
                            <div class="flex" v-else>
                              <img src="../assets/images/ribbonFilled.png" alt="" style="width: 18px; margin-right: 10px" class="left-margin-5 cursor-pointer" @click="followReco(reco_data.strategy.id, index, 'UNFOLLOW')" />
                              Added to watchlist
                            </div>

                            <div class="flex top-margin-10 cursor-pointer" @click="copyToClipboard(reco_data)">
                              <img class="left-margin-5" src="../assets/images/Copy.svg" style="width: 14px; margin-right: 10px" alt="" />
                              Copy Strategy details
                            </div>
                            <!-- <p v-if="isCopied" class="copied-text">
                              Strategy Copied!
                            </p> -->
                          </div>

                          <img class="info-Logo cursor-pointer" src="../assets/images/menu.png" style="width: 24px; top: 0" slot="reference" alt="" />
                        </el-popover>
                        <div v-else>
                          <img class="cursor-pointer" v-if="!reco_data.is_reco_subscribe_for_notification" @click="followReco(reco_data.strategy.id, index, 'FOLLOW')" src="../assets/images/ribbon.png" alt="" style="width: 18px" />
                          <img class="cursor-pointer" v-else src="../assets/images/ribbonFilled.png" alt="" style="width: 18px" @click="followReco(reco_data.strategy.id, index, 'UNFOLLOW')" />
                        </div>
                      </span>

                      <span v-else-if="$router.currentRoute.path == '/past-strategy-options' && userProfile.mark_as_verified_user" @click="copyToClipboard(reco_data)">
                        <img class="cursor-pointer" src="../assets/images/Copy.svg" style="width: 14px; position: relative; top: 2px; margin: 0 5px" alt="" />
                      </span>
                    </label>

                    <div class="flex-end top-margin-5" style="align-items: flex-start">
                      <div>
                        <span class="secondary-theme-color text-right font-09rem cursor-pointer" v-if="(reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'YET_TO_LIVE') && currentComponent == 'PastStrategyOptions'" @click="editReco(reco_data, index)">
                          <i class="el-icon-edit"></i>
                        </span>

                        <span class="download-btn" style="text-align: right; margin-left: 5px" v-if="reco_data.strategy.status == 'LIVE' && currentComponent == 'PastStrategyOptions'" @click="exitReco(reco_data.strategy.id, index)">Exit</span>
                      </div>
                    </div>
                    <div
                      v-if="reco_data.strategy.risk_tag && reco_data.strategy.risk_tag.length"
                      class="tags"
                      :style="[
                        reco_data.strategy.risk_tag == 'Low Risk'
                          ? { backgroundColor: '#ECFFF3', color: '#0BA042' } // text color for low_risk
                          : reco_data.strategy.risk_tag == 'Moderate Risk'
                          ? { backgroundColor: '#FFF6E6', color: '#EDB21A' } // text color for moderate_risk
                          : reco_data.strategy.risk_tag == 'High Risk'
                          ? { backgroundColor: '#FFF1F1', color: '#EA2526' } // Text color for high_risk
                          : { backgroundColor: '#FFF6E6', color: '#EDB21A' }, // Default text color for moderate_risk
                        { textTransform: 'capitalize' }, // Capitalize the text
                      ]"
                    >
                      {{ reco_data.strategy.risk_tag }}
                    </div>
                    <div
                      v-else
                      class="tags"
                      :style="{
                        backgroundColor: '#FFF6E6',
                        color: '#EDB21A',
                        textTransform: 'capitalize',
                      }"
                    >
                      Moderate Risk
                    </div>
                  </div>
                </div>
              </div>

              <!-- stock details section -->
              <div class="border-bottom-gray top-margin-5"></div>

              <el-row class="top-margin-15 reco-details">
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <div class="flex-space-between flex-wrap">
                        <div style="display: flex">
                          <div class="cursor-pointer" @click="goToExpertStore(reco_data.strategy.user_details)">
                            <img v-if="!reco_data.strategy.user_details.pic" src="../assets/images/navBar/avatar.jpg" class="user-profile-pic" alt />

                            <img v-else :src="serverHostName + reco_data.strategy.user_details.pic" class="user-profile-pic" alt />
                          </div>

                          <div class="company-employee-details">
                            <div class="label-lg-black-bold right-margin-3" style="text-transform: capitalize; font-size: 14px">
                              <span>{{ reco_data.strategy.user_details.full_name }}</span>
                              <el-tooltip v-if="reco_data.strategy.user_details.mark_as_verified_user" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
                                <!-- <i class="el-icon-success" style="color: #2d2e8d"></i> -->
                                <img class="info-Logo cursor-pointer" src="../assets/images/verify.svg" style="width: 16px" alt />
                              </el-tooltip>
                            </div>

                            <!-- if recos filtered by company id then displyaed their campany name followed by profession -->
                            <span>
                              <span class="right-margin-3 input-label-gray">{{ reco_data.strategy.user_details.profession }}</span>
                            </span>

                            <br />
                            <span class="right-margin-3 input-label-gray">
                              Total Strategy -
                              <span class="input-label-bold-gray">
                                {{ reco_data.strategy.user_details.total_strategy ? reco_data.strategy.user_details.total_strategy : 0 }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>

                  <div class="faded-border-bottom target-period-section-border top-margin-20">&nbsp;</div>
                </el-col>

                <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                  <el-row class="performance-accuracy-container">
                    <el-col :xs="24" :sm="11" :md="11" :lg="11" :xl="11">
                      <div class="performance-section">
                        <el-tooltip class="item" effect="dark" placement="top" :content="reco_data.strategy.status == 'YET_TO_LIVE' ? '0' : reco_data.strategy.avg_performance + '%'" :disabled="reco_data.strategy.status == 'YET_TO_LIVE'">
                          <NewCircleProgress v-if="reco_data.strategy.status == 'YET_TO_LIVE'" :value="reco_data.strategy.status == 'YET_TO_LIVE' ? 0 : reco_data.strategy.wheel_status" :transitionDuration="5000" :radius="44" :strokeWidth="10" :strokeColor="'#079e3e'">
                            <div class style="font-size: 0.6rem">
                              <!-- {{ reco_data.strategy.status }} -->
                              {{ reco_data.strategy.status ? reco_data.strategy.status.replace(/_/g, ' ') : '' }}
                            </div>
                            <template v-slot:footer></template>
                          </NewCircleProgress>
                          <NewCircleProgress v-else :value="reco_data.strategy.wheel_status > 100 ? 100 : reco_data.strategy.wheel_status" :transitionDuration="5000" :radius="44" :strokeWidth="10" :strokeColor="(reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'UPDATED' || reco_data.strategy.status == 'CLOSED' || reco_data.strategy.status == 'EXIT' || reco_data.strategy.status == 'STOPLOSS_TRIGGERED' || reco_data.strategy.status == 'TARGET_NOT_ACHIEVED') && reco_data.strategy.wheel_status > 0 ? '#079e3e' : (reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'UPDATED' || reco_data.strategy.status == 'CLOSED' || reco_data.strategy.status == 'EXIT' || reco_data.strategy.status == 'STOPLOSS_TRIGGERED' || reco_data.strategy.status == 'INCOMPLETE' || reco_data.strategy.status == 'TARGET_NOT_ACHIEVED') && reco_data.strategy.wheel_status < 0 ? '#d60918' : '#079e3e'">
                            <div class style="font-size: 0.6rem">
                              <!-- {{ reco_data.strategy.status }} -->
                              {{ reco_data.strategy.status ? reco_data.strategy.status.replace(/_/g, ' ') : '' }}
                            </div>
                            <template v-slot:footer></template>
                          </NewCircleProgress>
                        </el-tooltip>

                        <div class="progress-description">
                          <div class="input-label-bold-gray" style="margin-top: 0">
                            <!--if only reco status is live, YET_TO_LIVE and updated -->
                            <span v-if="reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'YET_TO_LIVE' || reco_data.strategy.status == 'UPDATED'">As on {{ reco_data.strategy.today | formatDate }}</span>

                            <span v-else>
                              As on
                              {{ reco_data.strategy.last_event_timestamp | formatDate }}
                            </span>

                            <!-- reco duration section -->
                            <!-- if reco status is live, YET_TO_LIVE, STOPLOSS_TRIGGERED and current date is reco date then displayed -->
                            <div class="input-label-bold-gray top-margin-5" v-if="reco_data.strategy.difference_in_days == 0">(Today)</div>

                            <!-- if only reco status is live, YET_TO_LIVE, STOPLOSS_TRIGGERED, TARGET_ACHIEVED, TARGET_NOT_ACHIEVED and current date is greater than reco date -->
                            <div class="input-label-bold-gray top-margin-5" v-if="reco_data.strategy.difference_in_days != 0">
                              ({{ reco_data.strategy.difference_in_days }}
                              <span v-if="reco_data.strategy.difference_in_days > 1">Days</span>
                              <span v-else>Day</span>
                              from reco date)
                            </div>

                            <!-- if reco status is updated and current date is reco date then displayed -->
                            <div class="input-label-bold-gray top-margin-5" v-if="reco_data.strategy.status == 'UPDATED' && reco_data.strategy.difference_in_days == 0">(Updated Today)</div>

                            <!-- if reco status is updated and current date is greater than reco date -->
                            <div class="input-label-bold-gray top-margin-5" v-if="reco_data.strategy.status == 'UPDATED' && reco_data.strategy.difference_in_days != 0">
                              ({{ reco_data.strategy.difference_in_days }}
                              <span v-if="reco_data.strategy.difference_in_days > 1">Days</span>
                              <span v-else>Day</span>
                              from updated reco date)
                            </div>

                            <!-- if reco status is TARGET_ACHIEVED, TARGET_NOT_ACHIEVED on same day (reco published day) then displayed -->
                            <div class="input-label-bold-gray top-margin-5" v-if="(reco_data.strategy.status == 'TARGET_ACHIEVED' || reco_data.strategy.status == 'TARGET_NOT_ACHIEVED') && reco_data.strategy.difference_in_days == 0">(On Reco date)</div>

                            <!-- if recos closed or TARGET_ACHIEVED on updated reco day then displayed -->
                            <div class="input-label-bold-gray top-margin-5" v-if="reco_data.has_close_reco && reco_data.strategy.difference_in_days == 0 && reco_data.strategy.status == 'TARGET_ACHIEVED'">(On Updated Reco date)</div>

                            <div class="progress-bar-legends-section top-margin-20">
                              <div class="flex">
                                <div class="progress-bar-legends" :style="[(reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'UPDATED' || reco_data.strategy.status == 'CLOSED' || reco_data.strategy.status == 'COMPLETE' || reco_data.strategy.status == 'EXIT' || reco_data.strategy.status == 'STOPLOSS_TRIGGERED' || reco_data.strategy.status == 'TARGET_NOT_ACHIEVED') && reco_data.strategy.wheel_status > 0 ? { 'background-color': '#079e3e' } : (reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'UPDATED' || reco_data.strategy.status == 'CLOSED' || reco_data.strategy.status == 'EXIT' || reco_data.strategy.status == 'COMPLETE' || reco_data.strategy.status == 'STOPLOSS_TRIGGERED' || reco_data.strategy.status == 'TARGET_NOT_ACHIEVED') && reco_data.strategy.wheel_status < 0 ? { 'background-color': '#d60918' } : reco_data.strategy.status == 'TARGET_ACHIEVED' ? { 'background-color': '#079e3e' } : { 'background-color': '#a29eab' }]">&nbsp;</div>
                                <div class="legends-text label-lg-black-bold">Performance</div>
                              </div>
                              <div class="flex top-margin-5 label-lg-black-bold">
                                <div class="progress-bar-legends">&nbsp;</div>
                                <div class="legends-text">Potential</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>

                    <el-col :xs="24" :sm="13" :md="13" :lg="13" :xl="13">
                      <div class="left-margin-20">
                        <div class="roi-card-main">
                          <div class="roi-card font-weight-600" style="color: #079e3e">
                            <div class="remaining-potential">
                              <div class="flex-center">
                                <p class="input-label-bold-gray">Remaining Target</p>

                                <span v-if="reco_data.data.length == 1 && reco_data.data[0].brokerage_data && currentEnvironment.loginModule != 'BlinkX'">
                                  <el-popover v-if="reco_data.data.length == 1 && reco_data.data[0].brokerage_data" popper-class="brokerage-calculator-popover" placement="bottom" width="240" trigger="click">
                                    <img class="info-Logo cursor-pointer" src="../assets/images/Brokrage Calculator.svg" style="width: 22px; height: 22px; padding: 0px 2px 0px 3px; position: relative; top: 2px; left: 3px" alt slot="reference" />

                                    <div class="brokerageCalculator" v-loading="reco_data.data[0].brokerage_loader">
                                      <table class="custom-element-ui-table" v-if="reco_data.data[0].brokerage_data">
                                        <thead>
                                          <tr>
                                            <th style="width: 150px">Trading Tax</th>
                                            <th style="width: 90px; text-align: center">Prices(in ₹)</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              {{ userProfile.utm_source == 'HDFC Sky' ? 'Brokerage' : 'Brokerage for buy' }}
                                            </td>
                                            <td style="text-align: center">
                                              <span v-if="userProfile.utm_source != 'GCL'">
                                                {{ reco_data.data[0].brokerage_data.buy_brokerage }}
                                              </span>

                                              <span v-else>
                                                <div class="edit-brokerage-input">
                                                  <el-input-number :controls="false" placeholder="Buy brokerage" v-model="reco_data.data[0].brokerage_data.buy_brokerage" @change="calculateBrokerageData(index)" style="width: 80px"></el-input-number>
                                                  <span style="position: absolute; right: 6px">
                                                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                                  </span>
                                                </div>
                                              </span>
                                            </td>
                                          </tr>
                                          <tr v-if="userProfile && userProfile.utm_source != 'HDFC Sky'">
                                            <td>Brokerage for Sell</td>
                                            <td style="text-align: center">
                                              <span v-if="userProfile.utm_source != 'GCL'">
                                                {{ reco_data.data[0].brokerage_data.sell_brokerage }}
                                              </span>
                                              <span v-else>
                                                <div class="edit-brokerage-input">
                                                  <el-input-number :controls="false" placeholder="Sell brokerage" v-model="reco_data.data[0].brokerage_data.sell_brokerage" @change="calculateBrokerageData(index)" style="width: 80px"></el-input-number>
                                                  <span style="position: absolute; right: 6px">
                                                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                                  </span>
                                                </div>
                                              </span>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>STT</td>
                                            <td style="text-align: center">
                                              {{ reco_data.data[0].brokerage_data.stt }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Transaction Charge</td>
                                            <td style="text-align: center">
                                              {{ reco_data.data[0].brokerage_data.exchange_txn_charge }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>GST</td>
                                            <td style="text-align: center">
                                              {{ reco_data.data[0].brokerage_data.gst }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Stamp Duty</td>
                                            <td style="text-align: center">
                                              {{ reco_data.data[0].brokerage_data.stamp_duty }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>SEBI Charges</td>
                                            <td style="text-align: center">
                                              {{ reco_data.data[0].brokerage_data.sebi_charges }}
                                            </td>
                                          </tr>
                                          <tr v-if="userProfile && userProfile.utm_source == 'Zebu' && reco_data.data[0].brokerage_data.cm_charges">
                                            <td>Cm Charges</td>
                                            <td style="text-align: center">
                                              {{ reco_data.data[0].brokerage_data.cm_charges }}
                                            </td>
                                          </tr>
                                          <tr class="font-weight-600" style="color: #636161; font-size: 12px">
                                            <td>Total Tax & Charges</td>
                                            <td style="text-align: center">
                                              {{ reco_data.data[0].brokerage_data.total_tax_and_charges }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      <div class="flex-space-between" v-if="$route.path != '/options-insights' && $route.path != '/options/expert-view'">
                                        <div>
                                          <label class="input-label block bottom-margin-5 top-margin-20">Quantity</label>

                                          <el-input-number v-model="reco_data.data[0].lot_quantity" controls-position="right" @change="calculateBrokerageData(index)" size="mini" style="width: 100px" :min="1"></el-input-number>
                                        </div>

                                        <div>
                                          <label class="input-label block bottom-margin-5 top-margin-20">Exp. Tax</label>

                                          <div style="padding: 2px 5px; border: 1px solid #c0c4cc; border-radius: 4px; text-align: center">
                                            {{ reco_data.data[0].exp_tax }}
                                          </div>
                                        </div>
                                      </div>

                                      <div class="required-field font-06rem font-weight-600 top-margin-10" style="padding: 0 8px">Note: The above charges are tentative. Please refer broker's contract note for exact charges.</div>
                                    </div>
                                  </el-popover>
                                </span>
                              </div>
                              <div class="font-weight-600 label-lg-black-bold">
                                <span class="label-md-bold-black" style="color: #079e3e">
                                  <span>{{ reco_data.strategy.avg_remaining_potential_in_perc ? isFloat(reco_data.strategy.avg_remaining_potential_in_perc) : '0' }}%</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="flex top-margin-20 text-center" v-if="reco_data.strategy.tag">
                          <div class="period-type-tag active-period-type-tag" :class="reco_data.strategy.tag == 'BEARISH' ? 'active-period-type-tag-red' : 'active-period-type-tag'" style="width: 47%; margin: 0">
                            {{ reco_data.strategy.tag }}
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <!-- <div class="faded-border-bottom bottom-margin-10">&nbsp;</div> -->

              <div class="disclaimer-card" style="float: right">
                <div class="input-label-bold-gray">
                  <el-popover placement="bottom" title="Disclaimer" width="200" trigger="click" content="Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.">
                    <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg" style="height: 12px; top: 1px" alt slot="reference" />
                  </el-popover>
                  Disclaimer
                </div>
              </div>
              <!-- Toggle More Info Section -->
              <div class="flex flex-center">
                <span class="input-label-gray cursor-pointer" style="color: red; margin: 0px 0px 40px 0px; text-transform: capitalize; cursor: pointer" @click="toggleMoreInfo(index, reco_data)" v-if="reco_data.toggle_more_info">
                  Less details
                  <i class="el-icon-arrow-down"></i>
                </span>
                <span class="input-label-gray cursor-pointer" style="margin: 10px 0px; color: red; text-transform: capitalize" icon @click="toggleMoreInfo(index, reco_data)" v-else>
                  {{ reco_data.strategy.user_details.full_name ? reco_data.strategy.user_details.full_name.split(' ')[0] + "'s" : '' }}
                  reco details
                  <i class="el-icon-arrow-down"></i>
                </span>
              </div>

              <el-row v-if="reco_data.toggle_more_info">
                <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4">&nbsp;</el-col>

                <!-- Non-CLOSED row-->
                <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
                  <div style="border: 1px solid #d9d9d9; padding: 20px; border-radius: 20px; position: relative">
                    <div style="position: absolute; top: -25px; left: 10px; color: #878787; padding: 0 10px; font-size: 12px">Updated on: {{ moment(reco_data.strategy.last_event_timestamp).format('MMMM DD YYYY hh:mm A [IST]') }}</div>

                    <div v-for="(graphData, graphIndex) in reco_data.data.filter((item) => item.status !== 'CLOSED')" :key="graphIndex">
                      <StockProgress
                        :stockData="graphData"
                        :selectedIndex="graphIndex"
                        :strategyData="{
                          strategy: reco_data,
                          legLength: reco_data.data.length,
                          strategyType: reco_data.strategy.tag,
                          max_profit: reco_data.strategy.avg_profit,
                          max_profit_in_percentage: reco_data.strategy.avg_profit_in_percentage,
                          max_loss: reco_data.strategy.avg_loss,
                          max_loss_in_percentage: reco_data.strategy.avg_loss_in_percentage,
                          capitalRequired: reco_data.strategy.required_total_margin,
                        }"
                        :segment="'Options'"
                        @strategyBrokerage="getStrategyBrokerageData"
                      ></StockProgress>

                      <!-- Horizontal line separator between non-CLOSED items -->
                      <hr v-if="graphIndex + 1 < reco_data.data.filter((item) => item.status !== 'CLOSED').length" />
                    </div>
                  </div>
                </el-col>
              </el-row>

              <!-- Divider Line Between Non-CLOSED and CLOSED reco Rows -->
              <el-row v-if="reco_data.toggle_more_info && reco_data.data.some((item) => item.status === 'CLOSED')">
                <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4">&nbsp;</el-col>
                <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
                  <hr style="border: none; border-top: 1px solid #d9d9d9; margin: 30px 0" />
                </el-col>
              </el-row>

              <el-row v-if="reco_data.toggle_more_info">
                <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4">&nbsp;</el-col>

                <!-- CLOSED rows with header -->
                <el-col v-if="reco_data.data.some((item) => item.status === 'CLOSED')" :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
                  <div style="border: 1px solid #d9d9d9; padding: 20px; border-radius: 20px; position: relative">
                    <!-- Header for CLOSED rows -->
                    <div style="position: absolute; top: -20px; left: 10px; background-color: white; padding: 0 10px; font-size: 12px; font-weight: bold">Previous Strategies</div>

                    <div v-for="(graphData, graphIndex) in reco_data.data.filter((item) => item.status === 'CLOSED')" :key="graphIndex">
                      <StockProgress
                        :stockData="graphData"
                        :selectedIndex="graphIndex"
                        :strategyData="{
                          strategy: reco_data,
                          legLength: reco_data.data.length,
                          strategyType: reco_data.strategy.tag,
                          max_profit: reco_data.strategy.avg_profit,
                          max_profit_in_percentage: reco_data.strategy.avg_profit_in_percentage,
                          max_loss: reco_data.strategy.avg_loss,
                          max_loss_in_percentage: reco_data.strategy.avg_loss_in_percentage,
                          capitalRequired: reco_data.strategy.required_total_margin,
                        }"
                        :segment="'Options'"
                        @strategyBrokerage="getStrategyBrokerageData"
                      ></StockProgress>

                      <!-- Horizontal line separator between CLOSED items -->
                      <hr v-if="graphIndex + 1 < reco_data.data.filter((item) => item.status === 'CLOSED').length" />
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <PremiumLock v-if="index != 0 && $route.path == '/expert-past-strategy-options'"></PremiumLock>
          </div>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-for="(reco_data, index) in recommendationsList" :key="index" v-if="!isDesktopExpertView">
        <el-card
          class="box-card box-card-two"
          v-loading="reco_data.is_loading"
          :style="[
            (subscribedPlanDetails.plan == 'Lite' || !subscribedPlanDetails.plan) && index != 0 && $route.path == '/expert-past-strategy-options'
              ? {}
              : reco_data.strategy.risk_tag == 'Low Risk'
              ? { boxShadow: '7px 0px 0px -1px #0BA042' } // box-shadow for low_risk
              : reco_data.strategy.risk_tag == 'Moderate Risk'
              ? { boxShadow: '7px 0px 0px -1px #FFB800' } // box-shadow for moderate_risk
              : reco_data.strategy.risk_tag == 'High Risk'
              ? { boxShadow: '7px 0px 0px -1px #EA2526' } // Box-shadow for high_risk
              : { boxShadow: '7px 0px 0px -1px #FFB800' }, // Default box-shadow for moderate_risk
          ]"
        >
          <div style="position: relative">
            <div
              :style="[
                index != 0 && $route.path == '/expert-past-strategy-options' && (subscribedPlanDetails.plan == 'Lite' || !subscribedPlanDetails.plan)
                  ? {
                      cursor: 'pointer',
                      pointerEvents: 'none',
                      minHeight: '350px',
                    }
                  : 'pointer',
              ]"
            >
              <div class="inner-card">
                <div class="reco-date-mobile text-right">
                  <label class="input-label-gray flex-end" style="font-size: 11px">
                    Strategy Date :
                    {{ reco_data.strategy.created_date | stock_live_price_date_filter }}

                    <span style="position: relative; top: 2px; left: 4px" v-if="currentComponent != 'PastStrategyOptions'">
                      <el-popover v-if="userProfile.extra_info && userProfile.extra_info.can_copy_reco_data" placement="bottom" trigger="click" style="margin-bottom: 4px">
                        <div style="width: 170px !important">
                          <div class="flex" v-if="!reco_data.is_reco_subscribe_for_notification">
                            <img src="../assets/images/ribbon.png" alt="" style="width: 18px; margin-right: 10px" class="left-margin-5 cursor-pointer" v-on:click="followReco(reco_data.strategy.id, index, 'FOLLOW')" />
                            Add to watchlist
                          </div>
                          <div class="flex" v-else>
                            <img src="../assets/images/ribbonFilled.png" alt="" style="width: 18px; margin-right: 10px" class="left-margin-5 cursor-pointer" @click="followReco(reco_data.strategy.id, index, 'UNFOLLOW')" />
                            Added to watchlist
                          </div>

                          <div class="flex top-margin-10 cursor-pointer" @click="copyToClipboard(reco_data)">
                            <img class="left-margin-5" src="../assets/images/Copy.svg" style="width: 14px; margin-right: 10px" alt="" />
                            Copy Strategy details
                          </div>
                          <!-- <p v-if="isCopied" class="copied-text">
                            Strategy Copied!
                          </p> -->
                        </div>

                        <img class="info-Logo cursor-pointer" src="../assets/images/menu.png" style="width: 24px; top: 0" slot="reference" alt="" />
                      </el-popover>
                      <div v-else>
                        <img @click="followReco(reco_data.strategy.id, index, 'FOLLOW')" src="../assets/images/ribbon.png" alt="" style="width: 18px" class="cursor-pointer" v-if="!reco_data.is_reco_subscribe_for_notification" />
                        <img v-else src="../assets/images/ribbonFilled.png" alt="" style="width: 18px" @click="followReco(reco_data.strategy.id, index, 'UNFOLLOW')" class="cursor-pointer" />
                      </div>
                    </span>
                    <span v-else-if="$router.currentRoute.path == '/past-strategy-options' && userProfile.mark_as_verified_user" @click="copyToClipboard(reco_data)">
                      <img class="cursor-pointer" src="../assets/images/Copy.svg" style="width: 14px; position: relative; top: 2px; margin: 0 5px" alt="" />
                    </span>
                  </label>

                  <div class="flex-end" style="align-items: flex-start">
                    <span class="label-xs-bold">
                      {{ reco_data.duration == 'Week' || reco_data.duration == 'Month' ? 'Short Term' : reco_data.duration == 'Quarter' ? 'Mid Term' : reco_data.duration }}
                    </span>
                  </div>

                  <div>
                    <span class="secondary-theme-color text-right font-09rem cursor-pointer" style="margin-left: 10px" v-if="(reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'YET_TO_LIVE') && currentComponent == 'PastStrategyOptions'" @click="editReco(reco_data, index)">
                      <i class="el-icon-edit"></i>
                    </span>

                    <span class="download-btn" style="text-align: right" v-if="reco_data.strategy.status == 'LIVE' && currentComponent == 'PastStrategyOptions'" @click="exitReco(reco_data.strategy.id, index)">Exit</span>
                  </div>

                  <div
                    v-if="reco_data.strategy.risk_tag && reco_data.strategy.risk_tag.length"
                    class="tags"
                    :style="[
                      reco_data.strategy.risk_tag == 'Low Risk'
                        ? { backgroundColor: '#ECFFF3', color: '#0BA042' } // text color for low_risk
                        : reco_data.strategy.risk_tag == 'Moderate Risk'
                        ? { backgroundColor: '#FFF6E6', color: '#EDB21A' } // text color for moderate_risk
                        : reco_data.strategy.risk_tag == 'High Risk'
                        ? { backgroundColor: '#FFF1F1', color: '#EA2526' } // Text color for high_risk
                        : { backgroundColor: '#FFF6E6', color: '#EDB21A' }, // Default text color for moderate_risk
                      { textTransform: 'capitalize' }, // Capitalize the text
                    ]"
                  >
                    {{ reco_data.strategy.risk_tag }}
                  </div>
                  <div
                    v-else
                    class="tags"
                    :style="{
                      backgroundColor: '#FFF6E6',
                      color: '#EDB21A',
                      textTransform: 'capitalize',
                    }"
                  >
                    Moderate Risk
                  </div>
                </div>
                <div class="first-sec">
                  <div class="flex-space-between profile-antestimateSection bottom-margin-10 flex-wrap">
                    <div class="flex" style="align-items: unset">
                      <div class="cursor-pointer" @click="goToExpertStore(reco_data.strategy.user_details)">
                        <img v-if="!reco_data.strategy.user_details.pic || reco_data.filtered_by == 'company'" src="../assets/images/navBar/avatar.jpg" class="user-profile-pic" alt />

                        <img v-else :src="serverHostName + reco_data.strategy.user_details.pic" class="user-profile-pic" alt />
                      </div>

                      <!-- if current route is not expert sections route then applied cursor pointer style to expert's name -->
                      <div class="company-employee-details">
                        <div class="flex">
                          <div class="label-lg-black-bold right-margin-3" :style="[$router.currentRoute.path == '/expert-past-strategy-options' ? { cursor: 'pointer' } : { cursor: 'text' }]" @click="getRecoByExpert(reco_data)" style="text-transform: capitalize; font-size: 14px">
                            <!-- if filtered by company id then displyaed company name other wise user name -->
                            <span v-if="reco_data.filtered_by == 'company'">{{ reco_data.strategy.user_details.company.name }}</span>
                            <span v-else>{{ reco_data.strategy.user_details.full_name }}</span>
                            <el-tooltip v-if="reco_data.strategy.user_details.mark_as_verified_user" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
                              <!-- <i class="el-icon-success" style="color: #2d2e8d"></i> -->
                              <img class="info-Logo cursor-pointer" src="../assets/images/verify.svg" style="width: 16px" alt />
                            </el-tooltip>
                          </div>
                        </div>

                        <!-- if recos filtered by company id then displyaed their campany name followed by profession -->
                        <span v-if="reco_data.filtered_by == 'company'">
                          <span class="right-margin-3 input-label-gray">
                            {{ reco_data.strategy.user_details.full_name }}
                            -
                          </span>
                          <span class="right-margin-3 input-label-gray">{{ reco_data.strategy.user_details.profession }}</span>
                        </span>

                        <span v-if="reco_data.filtered_by != 'company'" class="input-label-gray" style="font-size: 11px">
                          <span class="right-margin-3" v-if="reco_data.strategy.user_details.company && reco_data.strategy.user_details.profession != 'Student'">
                            {{ reco_data.strategy.user_details.company.name }}
                            -
                          </span>

                          <span class="right-margin-3" v-if="reco_data.strategy.user_details.profession == 'Student' && reco_data.strategy.user_details.institute_name">
                            {{ reco_data.strategy.user_details.institute_name }}
                            -
                          </span>

                          <span class="right-margin-3">{{ reco_data.strategy.user_details.profession }}</span>
                        </span>

                        <img v-if="reco_data.source == 'marketplace'" src="../assets/images/loudspeaker1.svg" width="17" height="17" title="Public recommendation" style="vertical-align: middle; margin-left: 5px" />

                        <br />
                      </div>
                    </div>
                  </div>
                  <div class="reco-date-desktop text-right">
                    <label class="input-label-gray" style="font-size: 11px">
                      Strategy Date :
                      {{ reco_data.strategy.created_date | stock_live_price_date_filter }}
                      <span style="position: relative; top: 2px; left: 4px" v-if="currentComponent != 'PastStrategyOptions'">
                        <el-popover v-if="userProfile.extra_info && userProfile.extra_info.can_copy_reco_data" placement="bottom" trigger="click" style="margin-bottom: 4px">
                          <div style="width: 170px !important">
                            <div class="flex" v-if="!reco_data.is_reco_subscribe_for_notification">
                              <img src="../assets/images/ribbon.png" alt="" style="width: 18px; margin-right: 10px" class="left-margin-5 cursor-pointer" v-on:click="followReco(reco_data.strategy.id, index, 'FOLLOW')" />
                              Add to watchlist
                            </div>
                            <div class="flex" v-else>
                              <img src="../assets/images/ribbonFilled.png" alt="" style="width: 18px; margin-right: 10px" class="left-margin-5 cursor-pointer" @click="followReco(reco_data.strategy.id, index, 'UNFOLLOW')" />
                              Added to watchlist
                            </div>

                            <div class="flex top-margin-10 cursor-pointer" @click="copyToClipboard(reco_data)">
                              <img class="left-margin-5" src="../assets/images/Copy.svg" style="width: 14px; margin-right: 10px" alt="" />
                              Copy Strategy details
                            </div>
                            <!-- <p v-if="isCopied" class="copied-text">
                              Strategy Copied!
                            </p> -->
                          </div>

                          <img class="info-Logo cursor-pointer" src="../assets/images/menu.png" style="width: 24px; top: 0" slot="reference" alt="" />
                        </el-popover>
                        <div v-else>
                          <img v-if="!reco_data.is_reco_subscribe_for_notification" @click="followReco(reco_data.strategy.id, index, 'FOLLOW')" src="../assets/images/ribbon.png" alt="" style="width: 18px" class="cursor-pointer" />
                          <img v-else src="../assets/images/ribbonFilled.png" alt="" style="width: 18px" @click="followReco(reco_data.strategy.id, index, 'UNFOLLOW')" class="cursor-pointer" />
                        </div>
                      </span>

                      <span v-else-if="$router.currentRoute.path == '/past-strategy-options' && userProfile.mark_as_verified_user" @click="copyToClipboard(reco_data)">
                        <img class="cursor-pointer" src="../assets/images/Copy.svg" style="width: 14px; position: relative; top: 2px; margin: 0 5px" alt="" />
                      </span>
                    </label>

                    <div class="flex-end">
                      <span class="label-xs-bold">
                        {{ reco_data.duration == 'Week' || reco_data.duration == 'Month' ? 'Short Term' : reco_data.duration == 'Quarter' ? 'Mid Term' : reco_data.duration }}
                      </span>
                    </div>
                    <div>
                      <span class="secondary-theme-color text-right font-09rem cursor-pointer" style="margin-left: 10px" v-if="(reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'YET_TO_LIVE') && currentComponent == 'PastStrategyOptions'" @click="editReco(reco_data, index)">
                        <i class="el-icon-edit"></i>
                      </span>

                      <span class="download-btn" style="text-align: right" v-if="reco_data.strategy.status == 'LIVE' && currentComponent == 'PastStrategyOptions'" @click="exitReco(reco_data.strategy.id, index)">Exit</span>
                    </div>
                    <div
                      v-if="reco_data.strategy.risk_tag && reco_data.strategy.risk_tag.length"
                      class="tags"
                      :style="[
                        reco_data.strategy.risk_tag == 'Low Risk'
                          ? { backgroundColor: '#ECFFF3', color: '#0BA042' } // text color for low_risk
                          : reco_data.strategy.risk_tag == 'Moderate Risk'
                          ? { backgroundColor: '#FFF6E6', color: '#EDB21A' } // text color for moderate_risk
                          : reco_data.strategy.risk_tag == 'High Risk'
                          ? { backgroundColor: '#FFF1F1', color: '#EA2526' } // Text color for high_risk
                          : { backgroundColor: '#FFF6E6', color: '#EDB21A' }, // Default text color for moderate_risk
                        { textTransform: 'capitalize' }, // Capitalize the text
                      ]"
                    >
                      {{ reco_data.strategy.risk_tag }}
                    </div>
                    <div
                      v-else
                      class="tags"
                      :style="{
                        backgroundColor: '#FFF6E6',
                        color: '#EDB21A',
                        textTransform: 'capitalize',
                      }"
                    >
                      Moderate Risk
                    </div>
                  </div>
                </div>

                <div class="second-sec">
                  <div class="">
                    <span class="stock-title cursor-pointer" v-if="reco_data.data.length == 1">
                      {{ reco_data.data[0].stock.title }}
                      {{ moment(reco_data.data[0].stock.expiry).format('D MMM YY' + "'") }}
                      {{ reco_data.data[0].stock.strike }}
                      {{ reco_data.data[0].stock.instrument_type }}
                    </span>
                    <span class="stock-title cursor-pointer" v-else>
                      {{ reco_data.strategy.title ? reco_data.strategy.title : '' }}
                      {{ reco_data.strategy.expiry ? moment(reco_data.strategy.expiry).format('DD MMM YYYY') : '' }}
                      <el-popover placement="bottom" trigger="click" style="position: relative; bottom: 4px">
                        <div style="margin: 0">
                          <div>
                            <div style="border-bottom: 1px solid #ddd; padding-bottom: 5px">
                              <div class="input-label-bold-gray">Description</div>

                              <div class="font-08rem" style="color: #000">
                                {{ reco_data.logic.length ? reco_data.logic[0].discription : '' }}
                              </div>
                            </div>

                            <div style="border-bottom: 1px solid #ddd; padding-bottom: 15px; margin-bottom: 15px">
                              <div class="input-label-bold-gray">Tags</div>
                              <div class="flex flex-wrap">
                                <div class="font-08rem" style="margin: 7px 5px" v-for="(subTags, tag_index) in reco_data.strategy.sub_tags" :key="tag_index">
                                  <span class="sub-tags">{{ subTags }}</span>
                                </div>
                              </div>
                            </div>

                            <div v-if="reco_data.logic[0]">
                              <div class="flex-space-between bottom-margin-5" v-for="(media, media_index) in reco_data.logic[0].mediaArray" :key="media_index">
                                <div class="input-label" style="font-size: 0.7rem">Attachment {{ media_index + 1 }}</div>

                                <div class="font-08rem primary-theme-color cursor-pointer" @click="downloadAttachment(media)">
                                  <i class="el-icon-download"></i>
                                  Download
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <img class="info-Logo cursor-pointer" src="../assets/images/Logic.svg" alt="" slot="reference" />
                      </el-popover>
                    </span>
                    &nbsp;
                  </div>
                </div>

                <div class="third-sec">
                  <el-row class="reco-details-section">
                    <el-col :xs="16" :sm="16" :md="16" :lg="18" :xl="18">
                      <el-row>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="small-box">
                          <div class="" v-if="reco_data.data.length == 1">
                            <div>
                              <span class="estimate-value right-margin-10" title="Current price">
                                ₹
                                {{ reco_data.data[0].stock.ltp }}
                              </span>

                              <span class="top-margin-10 stock-section-inc" :style="[reco_data.data[0].stock.price_change_in_rs >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
                                <span style="font-size: 18px" v-if="reco_data.data[0].stock.price_change_in_rs >= 0">&#9652;</span>
                                <span style="font-size: 18px" v-else>&#9662;</span>
                                {{ reco_data.data[0].stock.price_change_in_rs }}({{ reco_data.data[0].stock.price_change_in_percentage }}%)
                              </span>

                              <el-popover placement="bottom" trigger="click" style="position: relative; bottom: 4px">
                                <div style="margin: 0">
                                  <div>
                                    <div style="border-bottom: 1px solid #ddd; padding-bottom: 5px">
                                      <div class="input-label-bold-gray">Description</div>

                                      <div class="font-08rem" style="color: #000">
                                        {{ reco_data.logic.length ? reco_data.logic[0].discription : '' }}
                                      </div>
                                    </div>

                                    <div style="border-bottom: 1px solid #ddd; padding-bottom: 15px; margin-bottom: 15px">
                                      <div class="input-label-bold-gray">Tags</div>
                                      <div class="flex flex-wrap">
                                        <div class="font-08rem" style="margin: 7px 5px" v-for="(subTags, tag_index) in reco_data.strategy.sub_tags" :key="tag_index">
                                          <span class="sub-tags">
                                            {{ subTags }}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div v-if="reco_data.logic[0]">
                                      <div class="flex-space-between bottom-margin-5" v-for="(media, media_index) in reco_data.logic[0].mediaArray" :key="media_index">
                                        <div class="input-label" style="font-size: 0.7rem">Attachment {{ media_index + 1 }}</div>

                                        <div class="font-08rem primary-theme-color cursor-pointer" @click="downloadAttachment(media)">
                                          <i class="el-icon-download"></i>
                                          Download
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <img class="info-Logo cursor-pointer" src="../assets/images/Logic.svg" alt="" slot="reference" />
                              </el-popover>
                            </div>
                            <div class="input-label-gray" style="font-size: 10px">
                              {{ reco_data.data[0].stock.last_traded_timestamp | stock_live_price_date_filter }}
                            </div>
                          </div>
                          <div class="remaining-potential top-margin-15">
                            <label class="input-label-bold-gray">Remaining Target</label>

                            <span v-if="reco_data.data.length == 1 && reco_data.data[0].brokerage_data && currentEnvironment.loginModule != 'BlinkX'">
                              <el-popover v-if="reco_data.data.length == 1 && reco_data.data[0].brokerage_data" popper-class="brokerage-calculator-popover" placement="bottom" width="240" trigger="click">
                                <img class="info-Logo cursor-pointer" src="../assets/images/Brokrage Calculator.svg" style="width: 22px; height: 22px; padding: 0px 2px 0px 3px; position: relative; top: 8px; left: 3px" alt slot="reference" />

                                <div class="brokerageCalculator" v-loading="reco_data.data[0].brokerage_loader">
                                  <table class="custom-element-ui-table" v-if="reco_data.data[0].brokerage_data">
                                    <thead>
                                      <tr>
                                        <th style="width: 150px">Trading Tax</th>
                                        <th style="width: 90px; text-align: center">Prices(in ₹)</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          {{ userProfile.utm_source == 'HDFC Sky' ? 'Brokerage' : 'Brokerage for buy' }}
                                        </td>
                                        <td style="text-align: center">
                                          <span v-if="userProfile.utm_source != 'GCL'">
                                            {{ reco_data.data[0].brokerage_data.buy_brokerage }}
                                          </span>
                                          <span v-else>
                                            <div class="edit-brokerage-input">
                                              <el-input-number :controls="false" placeholder="Buy brokerage" v-model="reco_data.data[0].brokerage_data.buy_brokerage" @change="calculateBrokerageData(index)" style="width: 80px"></el-input-number>
                                              <span style="position: absolute; right: 6px">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                              </span>
                                            </div>
                                          </span>
                                        </td>
                                      </tr>
                                      <tr v-if="userProfile && userProfile.utm_source != 'HDFC Sky'">
                                        <td>Brokerage for Sell</td>
                                        <td style="text-align: center">
                                          <span v-if="userProfile.utm_source != 'GCL'">
                                            {{ reco_data.data[0].brokerage_data.sell_brokerage }}
                                          </span>
                                          <span v-else>
                                            <div class="edit-brokerage-input">
                                              <el-input-number :controls="false" placeholder="Sell brokerage" v-model="reco_data.data[0].brokerage_data.sell_brokerage" @change="calculateBrokerageData(index)" style="width: 80px"></el-input-number>
                                              <span style="position: absolute; right: 6px">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                                              </span>
                                            </div>
                                          </span>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>STT</td>
                                        <td style="text-align: center">
                                          {{ reco_data.data[0].brokerage_data.stt }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Transaction Charge</td>
                                        <td style="text-align: center">
                                          {{ reco_data.data[0].brokerage_data.exchange_txn_charge }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>GST</td>
                                        <td style="text-align: center">
                                          {{ reco_data.data[0].brokerage_data.gst }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Stamp Duty</td>
                                        <td style="text-align: center">
                                          {{ reco_data.data[0].brokerage_data.stamp_duty }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>SEBI Charges</td>
                                        <td style="text-align: center">
                                          {{ reco_data.data[0].brokerage_data.sebi_charges }}
                                        </td>
                                      </tr>
                                      <tr v-if="userProfile && userProfile.utm_source == 'Zebu' && reco_data.data[0].brokerage_data.cm_charges">
                                        <td>Cm Charges</td>
                                        <td style="text-align: center">
                                          {{ reco_data.data[0].brokerage_data.cm_charges }}
                                        </td>
                                      </tr>
                                      <tr class="font-weight-600" style="color: #636161; font-size: 12px">
                                        <td>Total Tax & Charges</td>
                                        <td style="text-align: center">
                                          {{ reco_data.data[0].brokerage_data.total_tax_and_charges }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  <div class="flex-space-between" v-if="$route.path != '/options-insights' && $route.path != '/options/expert-view'">
                                    <div>
                                      <label class="input-label block bottom-margin-5 top-margin-20">Quantity</label>

                                      <el-input-number v-model="reco_data.data[0].lot_quantity" controls-position="right" @change="calculateBrokerageData(index)" size="mini" style="width: 100px" :min="1"></el-input-number>
                                    </div>

                                    <div>
                                      <label class="input-label block bottom-margin-5 top-margin-20">Exp. Tax</label>

                                      <div style="padding: 2px 5px; border: 1px solid #c0c4cc; border-radius: 4px; text-align: center">
                                        {{ reco_data.data[0].exp_tax }}
                                      </div>
                                    </div>
                                  </div>

                                  <div class="required-field font-06rem font-weight-600 top-margin-10" style="padding: 0 8px">Note: The above charges are tentative. Please refer broker's contract note for exact charges.</div>
                                </div>
                              </el-popover>
                            </span>
                            <div class="font-weight-600 top-margin-5">
                              <span class="remaining-potential-btns">
                                <span style="color: #079e3e">{{ reco_data.strategy.avg_remaining_potential_in_perc ? isFloat(reco_data.strategy.avg_remaining_potential_in_perc) : '0' }}%</span>
                              </span>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>

                    <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="6" class="performance-circle">
                      <el-row class="performance-accuracy-container">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                          <div class="performance-section performance-section-two">
                            <el-tooltip class="item" effect="dark" placement="top" :content="reco_data.strategy.status == 'YET_TO_LIVE' ? '0' : reco_data.strategy.avg_performance + '%'" :disabled="reco_data.strategy.status == 'YET_TO_LIVE'">
                              <NewCircleProgress v-if="reco_data.strategy.status == 'YET_TO_LIVE'" :value="reco_data.strategy.status == 'YET_TO_LIVE' ? 0 : reco_data.strategy.wheel_status" :transitionDuration="5000" :radius="35" :strokeWidth="8" :strokeColor="'#079e3e'">
                                <div class style="font-size: 0.6rem; font-weight: 600; width: 70px">
                                  {{ reco_data.strategy.status ? reco_data.strategy.status.replace(/_/g, ' ') : '' }}
                                </div>
                                <template v-slot:footer></template>
                              </NewCircleProgress>
                              <NewCircleProgress v-else :value="reco_data.strategy.wheel_status > 100 ? 100 : reco_data.strategy.wheel_status" :transitionDuration="5000" :radius="35" :strokeWidth="8" :strokeColor="(reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'UPDATED' || reco_data.strategy.status == 'CLOSED' || reco_data.strategy.status == 'EXIT' || reco_data.strategy.status == 'STOPLOSS_TRIGGERED' || reco_data.strategy.status == 'TARGET_NOT_ACHIEVED') && reco_data.strategy.wheel_status > 0 ? '#079e3e' : (reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'UPDATED' || reco_data.strategy.status == 'CLOSED' || reco_data.strategy.status == 'EXIT' || reco_data.strategy.status == 'STOPLOSS_TRIGGERED' || reco_data.strategy.status == 'INCOMPLETE' || reco_data.strategy.status == 'TARGET_NOT_ACHIEVED') && reco_data.strategy.wheel_status < 0 ? '#d60918' : '#079e3e'">
                                <div class style="font-size: 0.6rem; font-weight: 600; width: 70px">
                                  <!-- {{ reco_data.strategy.status }} -->
                                  {{ reco_data.strategy.status ? reco_data.strategy.status.replace(/_/g, ' ') : '' }}
                                </div>
                                <template v-slot:footer></template>
                              </NewCircleProgress>
                            </el-tooltip>

                            <div class="progress-description">
                              <div class="input-label-gray">
                                <!--if only reco status is live, YET_TO_LIVE and updated -->
                                <span v-if="reco_data.strategy.status == 'LIVE' || reco_data.strategy.status == 'YET_TO_LIVE' || reco_data.strategy.status == 'UPDATED'">
                                  As on
                                  {{ reco_data.strategy.today | formatDate }}
                                </span>

                                <span v-else>
                                  As on
                                  {{ reco_data.strategy.last_event_timestamp | formatDate }}
                                </span>

                                <!-- reco duration section -->
                                <!-- if reco status is live, YET_TO_LIVE, STOPLOSS_TRIGGERED and current date is reco date then displayed -->
                                <div v-if="reco_data.strategy.difference_in_days == 0">(Today)</div>

                                <!-- if only reco status is live, YET_TO_LIVE, STOPLOSS_TRIGGERED, TARGET_ACHIEVED, TARGET_NOT_ACHIEVED and current date is greater than reco date -->
                                <div v-if="reco_data.strategy.difference_in_days != 0">
                                  ({{ reco_data.strategy.difference_in_days }}
                                  <span v-if="reco_data.strategy.difference_in_days > 1">Days</span>
                                  <span v-else>Day</span>
                                  from reco date)
                                </div>

                                <!-- if reco status is updated and current date is reco date then displayed -->
                                <div v-if="reco_data.strategy.status == 'UPDATED' && reco_data.strategy.difference_in_days == 0">(Updated Today)</div>

                                <!-- if reco status is updated and current date is greater than reco date -->
                                <div v-if="reco_data.strategy.status == 'UPDATED' && reco_data.strategy.difference_in_days != 0">
                                  ({{ reco_data.strategy.difference_in_days }}
                                  <span v-if="reco_data.strategy.difference_in_days > 1">Days</span>
                                  <span v-else>Day</span>
                                  from updated reco date)
                                </div>

                                <!-- if reco status is TARGET_ACHIEVED, TARGET_NOT_ACHIEVED on same day (reco published day) then displayed -->
                                <div v-if="(reco_data.strategy.status == 'TARGET_ACHIEVED' || reco_data.strategy.status == 'TARGET_NOT_ACHIEVED') && reco_data.strategy.difference_in_days == 0">(On Reco date)</div>

                                <!-- if recos closed or TARGET_ACHIEVED on updated reco day then displayed -->
                                <div v-if="reco_data.has_close_reco && reco_data.strategy.difference_in_days == 0 && reco_data.strategy.status == 'TARGET_ACHIEVED'">(On Updated Reco date)</div>
                              </div>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
              </div>

              <div class="flex top-margin-10" style="justify-content: space-between" v-if="reco_data.strategy.tag">
                <div class="period-type-tag active-period-type-tag" style="width: 100%">
                  {{ reco_data.strategy.tag }}
                </div>
              </div>
              <div class="disclaimer-card" style="float: right">
                <div class="input-label-bold-gray">
                  <el-popover placement="bottom" title="Disclaimer" width="200" trigger="click" content="Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.">
                    <img class="info-Logo cursor-pointer" src="../assets/images/Info.svg" style="height: 12px; top: 1px" alt slot="reference" />
                  </el-popover>
                  Disclaimer
                </div>
              </div>
              <div class="flex flex-center">
                <span class="input-label-gray cursor-pointer" icon style="color: red !important; margin: 20px 0px 10px; text-transform: capitalize" @click="toggleMoreInfo(index, reco_data)" v-if="reco_data.toggle_more_info">
                  Less details
                  <i class="el-icon-arrow-up"></i>
                </span>

                <span class="input-label-gray cursor-pointer" style="color: red !important; margin: 20px 0px 10px; text-transform: capitalize" icon @click="toggleMoreInfo(index, reco_data)" v-else>
                  {{ reco_data.strategy.user_details.full_name ? reco_data.strategy.user_details.full_name.split(' ')[0] + "'s" : '' }}
                  reco details
                  <i class="el-icon-arrow-down"></i>
                </span>
              </div>

              <div v-if="reco_data.toggle_more_info">
                <!-- Non-CLOSED items -->
                <div v-if="reco_data.data.some((item) => item.status !== 'CLOSED')" style="border: 1px solid #d9d9d9; padding: 20px; border-radius: 20px; position: relative; margin-bottom: 20px; margin-top: 20px">
                  <!-- Updated On for Non-CLOSED -->
                  <div style="position: absolute; top: -25px; left: 10px; color: #878787; padding: 0 10px; font-size: 12px">Updated on: {{ moment(reco_data.strategy.last_event_timestamp).format('MMMM DD YYYY hh:mm A [IST]') }}</div>

                  <div v-for="(graphData, graphIndex) in reco_data.data.filter((item) => item.status !== 'CLOSED')" :key="'non-closed-' + graphIndex">
                    <StockProgress
                      :stockData="graphData"
                      :selectedIndex="graphIndex"
                      :strategyData="{
                        strategy: reco_data,
                        legLength: reco_data.data.length,
                        strategyType: reco_data.strategy.tag,
                        max_profit: reco_data.strategy.avg_profit,
                        max_profit_in_percentage: reco_data.strategy.avg_profit_in_percentage,
                        max_loss: reco_data.strategy.avg_loss,
                        max_loss_in_percentage: reco_data.strategy.avg_loss_in_percentage,
                        capitalRequired: reco_data.strategy.required_total_margin,
                      }"
                      :segment="'Options'"
                      @strategyBrokerage="getStrategyBrokerageData"
                    ></StockProgress>

                    <!-- Horizontal line separator between non-CLOSED items -->
                    <div v-if="graphIndex + 1 < reco_data.data.filter((item) => item.status !== 'CLOSED').length" class="faded-border-bottom faded-border-margin">&nbsp;</div>
                  </div>
                </div>

                <!-- Divider Line Between Non-CLOSED and CLOSED -->
                <div v-if="reco_data.data.some((item) => item.status !== 'CLOSED') && reco_data.data.some((item) => item.status === 'CLOSED')">
                  <hr style="border: none; border-top: 1px solid #d9d9d9; margin: 30px 0" />
                </div>

                <!-- CLOSED items -->
                <div v-if="reco_data.data.some((item) => item.status === 'CLOSED')" style="border: 1px solid #d9d9d9; padding: 20px; border-radius: 20px; position: relative">
                  <!-- Header for CLOSED rows -->
                  <div style="position: absolute; top: -20px; left: 10px; background-color: white; padding: 0 10px; font-size: 12px; font-weight: bold">Previous Strategies</div>

                  <div v-for="(graphData, graphIndex) in reco_data.data.filter((item) => item.status === 'CLOSED')" :key="'closed-' + graphIndex">
                    <StockProgress
                      :stockData="graphData"
                      :selectedIndex="graphIndex"
                      :strategyData="{
                        strategy: reco_data,
                        legLength: reco_data.data.length,
                        strategyType: reco_data.strategy.tag,
                        max_profit: reco_data.strategy.avg_profit,
                        max_profit_in_percentage: reco_data.strategy.avg_profit_in_percentage,
                        max_loss: reco_data.strategy.avg_loss,
                        max_loss_in_percentage: reco_data.strategy.avg_loss_in_percentage,
                        capitalRequired: reco_data.strategy.required_total_margin,
                      }"
                      :segment="'Options'"
                      @strategyBrokerage="getStrategyBrokerageData"
                    ></StockProgress>

                    <!-- Horizontal line separator between CLOSED items -->
                    <div v-if="graphIndex + 1 < reco_data.data.filter((item) => item.status === 'CLOSED').length" class="faded-border-bottom faded-border-margin">&nbsp;</div>
                  </div>
                </div>
              </div>
            </div>

            <PremiumLock v-if="index != 0 && $route.path == '/expert-past-strategy-options'"></PremiumLock>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="selectedStrategyCard">
      <el-dialog :visible.sync="strategyDialogVisible">
        <div v-if="selectedStrategy.strategy">
          <div class="input-label-xs-bold-black uppercase">
            {{ selectedStrategy.strategy.title ? selectedStrategy.strategy.title : '' }}
            {{ selectedStrategy.strategy.expiry ? moment(selectedStrategy.strategy.expiry).format('DD MMMM YYYY') : '' }}
          </div>
          <!-- :before-close="handleClose" -->
          <div class="OptionStrategyCard">
            <div class="top-margin-20">
              <el-row :gutter="20" class="top-margin-20">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <div
                    v-if="strategyOverviewData != null"
                    class="strategy-graph-section"
                    :style="[
                      strategyOverviewData.status
                        ? {
                            backgroundColor: '#ffff',
                            paddingBottom: '7px',
                            borderRadius: '10px',
                            marginTop: '10px',
                            boxShadow: '0 2px 12px 0 rgb(0 0 0 / 10%)',
                          }
                        : {
                            backgroundColor: 'transparent',
                          },
                    ]"
                  >
                    <div class="graph-label-main-section" v-if="strategyOverviewData.status">
                      <div>&nbsp;</div>
                      <div class="graph-head">Pay-off Graph</div>
                      <div class="text-right info-label">
                        <div class="flex pl-tags">
                          Profit
                          <div class="graph-desc graph-desc-color-green"></div>
                        </div>
                        <div class="flex pl-tags">
                          Loss
                          <div class="graph-desc graph-desc-color-red"></div>
                        </div>
                      </div>
                    </div>
                    <div ref="strategy_graph" style="width: 100%; height: 287px"></div>

                    <div class="flex-center" style="font-size: 12px; color: #292929; margin-top: -5px; font-family: sans-serif">
                      <div v-if="strategyOverviewData.status">Price</div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="sentiment-card-dialog">
      <el-dialog :visible.sync="showTradeDialogue" :before-close="handleClose">
        <div>
          <Trade v-if="isDataChanged" />
        </div>
      </el-dialog>
    </div>

    <div class="text-center sellDialogue leaveConfirmationDialog">
      <el-dialog :visible.sync="leaveSiteConfirmationPopup" :show-close="false">
        <div class="header">
          <h3>!</h3>
        </div>
        <div class="body">
          <h3 style="color: #000">You are leaving StockAnts</h3>
          <p class="input-label-bold-gray">This will lead to redirection outside StockAnts</p>

          <p class="input-label-bold-gray top-margin-20">Do you want to continue ?</p>

          <div class="flex-center top-margin-10">
            <el-button class="btn-theme-gray-borderd" style="width: 50%" @click="goToDeepLinkTrade()">Continue</el-button>
            <el-button class="btn-theme-filled" style="width: 50%" @click="leaveSiteConfirmationPopup = false">Stay Here</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
var echarts = require('echarts');
import NewCircleProgress from './NewCircularProgress';
import Timer from './Timer';
import moment from 'moment';
import { EventBus } from '../eventBus';
import { derivativesApiCall } from '../mixins/DerivativesApi';
import { filterCallBack } from '../mixins/filter';
import { graphData } from '../mixins/LineGraphDataOptions';
import { serverAddr, serverHostName } from '../networkConfig';
import { HelperNetworkCallBack } from '../mixins/Helper';
import PremiumLock from './LockForPremiumPlan.vue';
import { screenSize } from '../mixins/ScreenSize.js';
import StockProgress from './StockProgressBarComponent.vue';
import CripNotice from 'crip-vue-notice';
import Trade from '@/components/Trade.vue';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
import { tradeCallback } from '../mixins/tradeMixin';

export default {
  name: 'OptionStrategyCard',
  props: ['recommendationsList'],

  mixins: [derivativesApiCall, filterCallBack, graphData, HelperNetworkCallBack, screenSize, updateProfileNetworkCallBack, tradeCallback],

  components: { NewCircleProgress, Timer, PremiumLock, StockProgress, Trade },

  data() {
    return {
      moment: moment,
      serverHostName: serverHostName,
      reco_data: '',
      selectedRecoType: 'bullish',
      toggleDetails: false,
      recommendationsCardList: [],
      currentComponent: '',
      strategyOverviewData: {},
      selectedStrategy: {},
      strategyDialogVisible: false,
      currentEnvironment: {},
      websiteUserType: {},
      isDataChanged: false,
      isCopied: false,
      copy_count_options: 0,
      hostUrl: '',
      jmClient: null,
      leaveSiteConfirmationPopup: false,
      is_profile_save_loading: false,
    };
  },

  mounted() {
    const profile = JSON.parse(localStorage.getItem('profile'));

    // Convert profile.id into a number without specifying radix
    this.profileId = profile && profile.id ? parseInt(profile.id) : null;
    // setTimeout(() => {
    // this.recommendationsCardList = this.recommendationsList;
    // }, 1000);
    this.currentComponent = this.$route.name;
    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));

      this.hostUrl = this.currentEnvironment.hostUrl;
    }

    if (localStorage.getItem('websiteUserType')) {
      this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));
    }

    // Localhost test setup
    if (window.location.href.includes('http://localhost:8080')) {
      // currentUrl = "supernalventures.stockants.com";
      this.userProfile.extra_info.can_copy_reco_data = true;
    }

    // get copy count from local storage
    this.copy_count_options = this.userProfile.extra_info && this.userProfile.extra_info.copy_count_options ? this.userProfile.extra_info.copy_count_options : 0;

    if (localStorage.getItem('jmClient')) {
      this.jmClient = JSON.parse(localStorage.getItem('jmClient'));
    }
  },

  watch: {},

  methods: {
    copyToClipboard(reco_details) {
      var broker_company_name = this.userProfile.extra_info.broker_company_name ? this.userProfile.extra_info.broker_company_name : '';

      var remaining_profit_sentence;
      if (reco_details.strategy.status == 'LIVE' || reco_details.strategy.status == 'YET_TO_LIVE' || reco_details.strategy.status == 'UPDATED') {
        remaining_profit_sentence = `${reco_details.strategy.avg_remaining_potential_in_perc}% as on ${moment(reco_details.strategy.last_event_timestamp).format('h:mma, Do MMM YYYY')} (on basis of minimum investment of 10 Lot)`;
      } else {
        remaining_profit_sentence = `${reco_details.strategy.avg_remaining_potential_in_perc}% (on basis of minimum investment of 10 Lot)`;
      }
      var paragraphKey = '';

      // Paragraph for single leg
      if (reco_details.data.length == 1) {
        paragraphKey = `*Published by:* ${reco_details.strategy.user_details.full_name} ${reco_details.strategy.user_details.mark_as_verified_user && reco_details.strategy.user_details.sebi_regi_number != null ? '(SEBI NO:' + reco_details.strategy.user_details.sebi_regi_number + ')' : ''}
*Indice Name:* ${reco_details.strategy.title} ${moment(reco_details.strategy.expiry).format('Do MMM YY')} ${reco_details.data.length == 1 ? reco_details.data[0].stock.strike : ''}${reco_details.data[0].stock.instrument_type}
*Strategy Type:* ${reco_details.strategy.tag}
*Call Type:* ${reco_details.data[0].direction}
*Approx Capital Required:* Rs. ${reco_details.strategy.ten_lot_total_margin} (on basis of minimum investment of 10 lot)
*Entry price:* Rs. ${reco_details.data[0].entry_premium}
*Strategy Time Stamp:* ${moment(reco_details.data[0].created_date).format('h:mma, Do MMM YYYY')}
*Target Price:* Rs. ${reco_details.data[0].target_premium} (10%)
*Stop Loss:* Rs. ${reco_details.data[0].stop_loss}
*Status:* ${reco_details.strategy.status}
*Remaining target:*  ${remaining_profit_sentence}

${broker_company_name ? '*' + broker_company_name + '*' : ''}

*_Powered By StockAnts_*

${this.hostUrl.length ? `Checkout ${this.hostUrl} for single access to multi–SEBI Experts’ Recommendations with Price estimate tracking.` : ''}
`;
      } else {
        // Paragraph for multi leg

        var leg_paragraph = '';
        var current_leg_para = '';
        for (let index = 0; index < reco_details.data.length; index++) {
          //
          current_leg_para = `*Leg ${index + 1}:*
*Leg Type:* ${reco_details.data[index].direction}
*Strike Price:* ${reco_details.data[index].stock.title}${moment(reco_details.data[index].stock.expiry).format('Do MMM YY')}${reco_details.data[index].stock.strike}${reco_details.data[index].stock.instrument_type}
*Entry price:* ${reco_details.data[index].current_premium}
*Target Price:* ${reco_details.data[index].target_premium}
*Stop Loss:* ${reco_details.data[index].stop_loss}

`;
          leg_paragraph = leg_paragraph + current_leg_para;
        }

        paragraphKey = `*Published by:* ${reco_details.strategy.user_details.full_name} ${reco_details.strategy.user_details.mark_as_verified_user && reco_details.strategy.user_details.sebi_regi_number != null ? '(SEBI NO:' + reco_details.strategy.user_details.sebi_regi_number + ')' : ''}
*Indice Name:* ${reco_details.strategy.title} ${moment(reco_details.strategy.expiry).format('Do MMM YY')}
*Strategy Time stamp:* ${moment(reco_details.data[0].created_date).format('h:mma, Do MMM YYYY')}
*Strategy Type:* ${reco_details.strategy.tag}
*Approx Capital Required:* Rs. ${reco_details.strategy.ten_lot_total_margin} (on basis of minimum investment of 10 lot)
*Status:* ${reco_details.strategy.status}
*Remaining target:*  ${remaining_profit_sentence}

${leg_paragraph}
${broker_company_name ? '*' + broker_company_name + '*' : ''}

*_Powered By StockAnts_* ${this.hostUrl.length ? `Checkout ${this.hostUrl} for single access to multi–SEBI Experts’ Recommendations with real time tracking.` : ''}`;
      }

      navigator.clipboard
        .writeText(paragraphKey)
        .then(() => {
          // Set isCopied to true to display the "Text Copied!" message
          this.isCopied = true;

          this.setCopyCount();

          new CripNotice({
            title: 'Success',
            description: 'Strategy Copied!',
            type: 'success',
            duration: 3,
          });

          // Reset isCopied after a short delay (e.g., 2 seconds)
          setTimeout(() => {
            this.isCopied = false;
          }, 2000);
        })
        .catch((err) => console.error('Unable to copy text to clipboard', err));

      // Simulate a click outside to close popover
      document.body.click();
    },

    setCopyCount() {
      this.copy_count_options++;
      serverAddr
        .post('/auth/v1/copy_paste_userwise_count', {
          copy_count_options: this.copy_count_options,
        })
        .then(this.getProfileCallBack)
        .catch((error) => {
          console.log(error);
        });
    },

    // openLeaveConfirmationPopup() {
    //   this.leaveSiteConfirmationPopup = true;
    // },

    goToDeepLinkTrade() {
      this.leaveSiteConfirmationPopup = false;
      if (this.jmClient) {
        window.open('https://pdxt.adj.st/?adj_t=11sjekac', '_blank');
      } else {
        window.open('https://signup.blinkx.in/diy/mobile?utm_source=edge&utm_medium=app&utm_campaign=diy', '_blank');
      }
    },
    calculateBrokerageData(index) {
      this.recommendationsList[index].data[0].brokerage_loader = true;
      var reco = this.recommendationsList[index].data[0];

      var obj = {
        strategy_id: this.recommendationsList[index].strategy.id,
        leg_id: this.recommendationsList[index].data[0].id,
        quantity: this.recommendationsList[index].data[0].lot_quantity,
      };

      if (this.userProfile.utm_source == 'GCL') {
        obj.buy_brokerage = reco.brokerage_data.buy_brokerage ? Number(reco.brokerage_data.buy_brokerage) : 0;
        obj.sell_brokerage = reco.brokerage_data.sell_brokerage ? Number(reco.brokerage_data.sell_brokerage) : 0;
      }

      serverAddr
        .post('options/option_brokerage_calculator', obj)
        .then((response) => {
          if (response.data.status) {
            var data = response.data.data.brokarage_calc;
            var received_data = data.filter((e) => {
              return e.leg_id == this.recommendationsList[index].data[0].id;
            })[0];

            this.recommendationsList[index].data[0].brokerage_data = received_data.fixed_brokarage_calc;
            this.recommendationsList[index].data[0].exp_tax = received_data.exp_tax;

            // to send data to options card component
            var strategy_data = {
              strategy_id: this.recommendationsList[index].strategy_id,
              strategy_level_brokerage: response.data.data.strategy_level_brokerage,
            };

            this.$emit('strategyBrokerage', strategy_data);
          }
          this.recommendationsList[index].data[0].brokerage_loader = false;
          // setTimeout(() => {
          //   this.selectedRecommendation.brokerage_loader = false;
          // }, 200);
        })
        .catch((error) => {
          this.recommendationsList[index].data[0].brokerage_loader = false;
          console.log(error);
        });
    },

    handleClose() {
      this.isDataChanged = false;
      this.$store.commit('tradePopupAction', false);
    },
    getStrategyBrokerageData(data) {
      var index = this.recommendationsList.findIndex((obj) => obj.strategy.id === data.strategy_id);
      this.$set(this.recommendationsList[index].strategy, 'strategy_level_brokerage', data.strategy_level_brokerage);
    },

    followReco(recoId, index, action) {
      serverAddr
        .post('base/v1/trigger_notification_for_trading', {
          reco_id: recoId,
          event: 'OPTION_TRADE_ON_MARKET_OPINION',
          watchlist_type: action,
        })
        .then((response) => {
          if (response.data.status) {
            if (action == 'FOLLOW' || action == 'TRADE') {
              if (index != undefined) {
                this.recommendationsList[index].is_reco_subscribe_for_notification = true;
              }
              new CripNotice({
                title: 'Success',
                description: `You followed ${this.recommendationsList[index].strategy.title + this.recommendationsList[index].strategy.expiry} strategy published by ${this.recommendationsList[index].strategy.user_details.full_name} `,
                type: 'success',
                duration: 2,
              });
            } else {
              if (index != undefined) {
                this.recommendationsList[index].is_reco_subscribe_for_notification = false;
              }

              if (this.$route.path == '/options-watchlist') {
                EventBus.$emit('updateFollowList', recoId);
              }
              new CripNotice({
                title: 'Success',
                description: `You unfollowed ${this.recommendationsList[index].strategy.title + this.recommendationsList[index].strategy.expiry} strategy`,
                type: 'success',
                duration: 2,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });

      // Simulate a click outside to close popover
      document.body.click();
    },

    goToExpertStore(expert) {
      // on selecting expert commited blank obj in store to cleare existing expert details
      this.$store.commit('commitExpertDetails', {});
      this.$router.push({
        path: '/expert-store',
        query: {
          user_id: expert.user_profile_id,
          user: 'individual',
          name: expert.full_name,
        },
      });
      // }
    },

    openStockWidgetDialog(stock_code) {
      this.$emit('openStockWidget', stock_code);
    },
    exitReco(reco_id, index) {
      this.exitRecoCallBack(reco_id, index);
    },
    editReco(reco_data, index) {
      this.$store.commit('optionEditStockData', reco_data);

      this.$router.push({ path: '/publish-recommendation-options' });
    },
    downloadAttachment(attachment_link) {
      if (attachment_link) {
        window.open(`https://dev-api.derivative.stockants.com${attachment_link}`, '_blank');
      }
    },
    toggleMoreInfo(index) {
      this.recommendationsList[index].toggle_more_info = !this.recommendationsList[index].toggle_more_info;
    },
    deleteLeg(id, index) {
      this.deleteStrategyLeg(id, index);
    },
  },

  computed: {
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    showTradeDialogue() {
      this.isDataChanged = this.$store.state.tradeDialogVisible ? true : false;
      return this.$store.state.tradeDialogVisible;
    },
  },

  beforeDestroy() {
    EventBus.$off('strategy-brokerage');
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.OptionStrategyCard {
  .period-type-tag {
    text-align: center;
    border-radius: 8px;
    padding: 8px 10px 10px;
    margin: 0 auto;
    color: #409eff;
    border: 1px solid;
    min-width: 50px;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 12px;
  }

  .active-period-type-tag {
    border-color: #079e3e;
    background-color: #079e3e;
    color: #fff !important;
  }

  .active-period-type-tag-yellow {
    border-color: #e2ba00;
    background-color: #e2ba00;
    color: #fff !important;
  }

  .active-period-type-tag-red {
    border-color: #d60918;
    background-color: #d60918;
    color: #fff !important;
  }

  .small-box-two {
    text-align: center;
    margin-top: 20px;
  }

  .remaining-potential-btns {
    background: #e9f9eff7;
    padding: 4px 5px;
    color: #079e3e;
    border-radius: 5px;
    margin-right: 3px;
  }

  .box-card-two {
    .performance-section {
      border: 0;
    }

    .download-btn {
      font-size: 8px;
      padding: 1px 5px 2px;
    }

    .reco-date-mobile,
    .mobile-view {
      display: none;
    }

    .first-sec {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .second-sec {
      margin-top: 15px;

      .stock-title {
        font-size: 18px;
      }

      .estimate-value {
        font-size: 16px;
      }
    }

    .third-sec {
      .input-label-gray {
        font-size: 10px;
      }

      .reco-details-section {
        display: flex;
        // align-items: center;
      }

      .right-border {
        border-right: 1px solid #e9e9e9;
        margin-right: 20px;
      }

      .small-box {
        // height: 60px;
        // position: relative;
        // top: 17px;
      }
    }
  }

  .reco-section {
    /* text-align: center; */
    display: flex;
    justify-content: center;
    border-right: 1px solid #ddd;

    .strategy-title {
      margin-top: 10px;
    }
  }

  .mobile-view {
    display: none;
  }

  .roi-card-main {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;

    .roi-card {
      // background-color: #e2e2e2;
      font-size: 0.7rem;
      // padding: 15px 5px;
      // margin: 7px;
      // width: 170px;
      // text-align: center;
      // border-radius: 5px;
      // box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.2);

      // font-weight: 600;
      p {
        margin: 0;
      }
    }
  }
}

.OptionStrategyCard .options-table {
  padding: 10px;
  border: 1px solid #d1cfcf;
  border-radius: 10px;

  .top-date-box {
    font-size: 12px;
    padding: 5px 12px;
    // border: 1px solid #d1cfcf;
    // width: 200px;
    // border-radius: 2px;
  }

  .circle {
    padding: 2px 10px;
    // border: 1px solid #d4d4d4;
    border-radius: 12px;
    margin: 5px;
    background: #d4d4d4;
    color: #fff;
    font-size: 9px;
    border: 1px solid;
  }

  table {
    width: 100%;
    min-width: 1000px;
    overflow-x: scroll;
    text-align: center;

    th {
      font-size: 0.75rem;
      color: $label-color;
      font-weight: 600;
      padding: 12px 5px;
    }

    td {
      font-size: 0.65rem;
      padding: 12px 5px;
      font-weight: 500;
    }
  }

  .legs-table-mobile-view {
    display: none;
  }
}

.reco-btns {
  max-width: 50px;
  margin: 0 0 10px 0 !important;
  display: block;
}

.reco-details {
  padding-bottom: 20px;
}

.target-period-section {
  display: flex !important;
  justify-content: center;
  border-right: 1px solid #ddd;
}

.target-period-details {
  display: block;
}

.performance-section {
  display: flex;
  justify-content: center;
  padding: 0 10px;
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
}

.progress-description {
  padding-left: 25px;
}

.progress-bar-legends {
  width: 12px;
  height: 12px;
  background-color: #a29eab;
  border-radius: 3px;
  margin: 0 10px 0 0;
}

.legends-text {
  font-size: 0.8rem;
  margin-right: 5px;
}

.accuracy-section {
  text-align: center;
  display: flex;
  flex-direction: column;
  // padding: 0!important;
}

.antestimate-block {
  text-align: center;
  border-radius: 20px;
  border: 1px solid #333;
  font-size: 0.8rem;
  font-weight: 500;
  color: #000;
  padding: 5px 10px;
  width: fit-content;
  margin: 5px auto;
}

.faded-border-bottom {
  display: block;
  border: none;
  color: #fff;
  height: 1px;
  margin: 20px 0 25px !important;
  background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 450, from(#f1f1f1), to(#fff));
}

.faded-border-margin {
}

.OptionStrategyCard .timer {
  align-self: center;
}

.OptionStrategyCard .cross-icon {
  color: #ddd;
  font-size: 20px;
}

.OptionStrategyCard .cross-icon:hover {
  font-size: 20px;
  color: black;
  cursor: pointer;
}

.OptionStrategyCard .border-bottom-gray {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.OptionStrategyCard .user-profile-pic {
  height: 38px;
  width: 38px;
  border-radius: 50px;
  margin-right: 10px;
  object-fit: cover;
}

.OptionStrategyCard .bottom-margin-10 {
  margin-bottom: 8px;
}

.OptionStrategyCard .flex-column {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
}

.OptionStrategyCard .reco-more-details-container {
  display: flex;
  justify-content: space-around;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 18px;
}

.OptionStrategyCard .vertical-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.OptionStrategyCard .info-Logo {
  height: 16px;
  // padding: 0px 2px 0px 3px;
  position: relative;
  top: 4px;
}

.expertPerformanceListSection {
  border-top: 1px dashed #ddd;
  padding: 5px 0 0;
  margin-top: 10px;
}

//media queries
@media screen and (max-width: 1284px) {
  .performance-section-two {
    display: block;
    text-align: center;

    .progress-description {
      text-align: center;
      padding: 0;
    }
  }
}

@media screen and (max-width: 1200px) {
  .reco-section {
    display: block;
    margin: 10px 0 0 0;
  }

  // .reco-btn-section {
  //   display: flex;
  // }
  .reco-btn-section .reco-btns {
    margin: 0 10px 0 0 !important;
  }

  .target-period-section {
    margin: 20px 0 0 0;
    display: flex !important;
    justify-content: space-between;
    border-right: none;
  }

  .target-period-details {
    display: flex;
    justify-content: space-between;
    width: 100%;
    /* border-bottom: 1px solid #ddd; */
    padding-bottom: 10px;
  }

  .period-contents {
    padding: 0 20px 0 0;
  }

  .performance-section {
    display: block;
    text-align: center;
  }

  .progress-description {
    padding: 0;
  }

  .progress-bar-legends-section {
    display: flex;
    justify-content: center;
    // text-align: center;
  }
}

@media screen and (min-width: 993px) {
  .OptionStrategyCard .isMobileView {
    display: none;
  }

  .target-period-section-border {
    display: none;
  }
}

@media screen and (max-width: 992px) {
  .OptionStrategyCard .reco-section {
    border-right: none;
  }

  .OptionStrategyCard .isDeskTopView {
    display: none;
  }

  .OptionStrategyCard .isMobileView {
    margin-top: 30px;
  }

  .performance-accuracy-container {
    margin-top: 20px;
  }

  .box-card-two .performance-accuracy-container {
    margin-top: 0px;
  }

  .performance-section {
    // display: flex;
  }

  .progress-bar-legends-section {
    flex-direction: column;
  }
}

@media screen and (max-width: 767px) {
  .remove-border {
    border: none !important;
  }

  .OptionStrategyCard {
    .mobile-view {
      display: block;
    }

    .desktop-view {
      display: none;
    }

    .performance-section {
      border: none;
    }

    .reco-section {
      border-right: none;
      margin-top: -25px;
      justify-content: flex-start;

      .strategy-title {
        margin-top: 0;
      }
    }

    .options-table .legs-table-mobile-view {
      display: block;

      // overflow-x: auto;
      table {
        width: 90%;
        min-width: unset;
        margin-left: 100px;

        tr {
          width: 100px;
          // height: 45px;
        }

        th {
          text-align: left;
          min-width: 115px;
          position: absolute;
          width: 5em;
          left: 20px;
          top: auto;
          background: #ffffff;
          padding: 10px 0;
        }

        td {
          min-width: 100px;
          // position: relative;
          // left: -50%;
        }
      }
    }

    .options-table .legs-table-desktop-view {
      display: none;
    }
  }
}

@media screen and (max-width: 680px) {
  .OptionStrategyCard {
    .box-card-two {
      .reco-date-mobile img {
        width: 15px !important;
        margin: 0;
      }

      .inner-card {
        // line-height: 0.7rem;
      }

      .label-xs-bold {
        font-size: 10px;
      }

      .performance-accuracy-container {
        margin-top: 0px;
      }

      .input-label-gray {
        font-size: 11px;
      }

      .mobile-view {
        display: block;
      }

      .desktop-view {
        display: none;
      }

      .third-sec {
        // .reco-details-section {
        //   display: unset;
        // }
        .performance-circle {
          // width: 100%;
        }

        .input-label-bold-gray {
          font-size: 10px;
        }

        .input-label-gray {
          font-size: 8px;
        }

        .label-md-bold-black {
          font-size: 12px !important;
        }

        .small-box {
          // top: 0px;
          // height: auto;
        }
      }

      .remaining-potential {
        // margin-top: 10px;
      }

      .second-sec {
        margin-top: 0;
      }
    }

    .capital-title,
    .remaining-potential-btns {
      font-size: 12px;
    }
  }
}

@media screen and (max-width: 680px) {
  .OptionStrategyCard .box-card-two {
    .reco-date-desktop {
      display: none;
    }

    .reco-date-mobile {
      display: block;
    }

    .third-sec {
      // margin: 10px 0;
      .right-border {
        margin-right: 10px;
      }
    }

    .remaining-potential {
      // margin: 10px 0 15px;
    }

    .second-sec {
      .code-title {
        font-size: 0.6rem;
      }

      .stock-title {
        font-size: 16px;
      }
    }

    .estimate-value {
      font-size: 14px !important;
    }
  }
}

@media screen and (max-width: 575px) {
  .company-employee-details {
    .ellipsis {
      max-width: 140px;
    }
  }

  .period-contents {
    padding: 0 0px 0 0;
  }

  .performance-section {
    padding: 0 5px;
  }

  .progress-bar-legends-section {
    display: block;
  }

  .accuracy-section {
    padding: 0 5px !important;
  }

  .faded-border-bottom {
    display: block;
    border: none;
    color: #fff;
    height: 1px;
    background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 250, from(#f1f1f1), to(#fff));
  }
}
</style>
<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.OptionStrategyCard {
  // .performance-dialogue {
  //   height: 270px;
  // }
}

.tags {
  float: right;
  width: auto;
  margin-top: 10px;
  padding: 4px 10px 4px 10px;
  text-transform: capitalize;
  font-size: 12px;
  font-weight: 500px;
  border-radius: 5px;
  position: relative !important;
  right: -20px !important;
}

.edit-brokerage-input {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-input__inner {
    text-align: center;
    border: none;
    height: 20px;
    line-height: 20px;
    font-size: 11px;
  }

  .el-input--suffix .el-input__inner {
    // padding: 0;
  }

  .el-input__icon {
    line-height: 20px;
  }

  .el-input-number .el-input {
    line-height: 20px;
  }
}

.OptionStrategyCard .leaveConfirmationDialog {
  .el-dialog {
    width: 280px;
    border-radius: 8px;
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .header {
    border-radius: 8px 8px 0 0;
    background-color: #ffeded;
    padding: 20px;

    h3 {
      color: red;
      margin: 0px auto;
      width: 20px;
      height: 20px;
      border: 2px solid;
      border-radius: 50%;
      padding: 2px;
      padding-left: 3px;
    }
  }

  .body {
    padding: 20px;
    text-align: left;

    h3 {
      margin: 0;
    }
  }
}

.OptionStrategyCard .sentiment-card-dialog {
  .el-dialog {
    margin-top: 100px;
    width: 550px;
    border-radius: 8px;
  }

  .el-dialog__body,
  .el-dialog__header {
    padding: 0px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    z-index: 2;
    position: relative;
  }
}

.remaining-potential-popover {
  // .el-popover {
  padding: 0px 7px !important;
}

// }

.OptionStrategyCard .selectedStrategyCard {
  .strategy-graph-section {
    width: 99%;
    margin: 0 auto;
    // background-color: #ffff;

    .graph-label-main-section {
      position: absolute;
      display: flex;
      justify-content: space-between;
      width: 98%;

      .graph-head {
        position: relative;
        top: 20px;
        text-align: center;
        font-size: 0.75rem;
        font-weight: 600;
        color: #2d2e8d;
      }

      .info-label {
        position: relative;
        left: -24px;
        top: 10px;
        background-color: #ffff;
        z-index: 1;
        width: 100px;
        height: 50px;

        .pl-tags {
          justify-content: end;
          font-size: 0.75rem;
          font-weight: 600;
          color: #2d2e8d;
          margin-bottom: 5px;
        }

        .graph-desc {
          width: 18px;
          height: 11px;
          margin-left: 7px;
          border-radius: 4px;
        }

        .graph-desc-color-red {
          background-color: #f0b6b6;
          border: 1px solid #f0b6b6;
        }

        .graph-desc-color-green {
          background-color: #a0eda0;
          border: 1px solid #a0eda0;
        }
      }
    }
  }

  .el-dialog {
    width: calc(100% - 310px);
    margin-left: 295px;
    border-radius: 10px;
  }

  .el-dialog__header {
    padding: 0;
  }
}

.OptionStrategyCard .box-card {
  border-radius: 10px !important;
  border: none;
  box-shadow: none;
}

.OptionStrategyCard .employee-select-box .el-input--mini .el-input__inner {
  height: 25px;
  border-radius: 8px;
  text-transform: capitalize;
}

.el-select-dropdown__list li {
  font-size: 12px;
}

.el-select-dropdown__item:hover {
  color: $primary-theme-color !important;
  background-color: #f5f7fa !important;
}

.el-select-dropdown__item.selected {
  color: $primary-theme-color;
}

.OptionStrategyCard .el-progress-bar {
  padding: 0;
}

.OptionStrategyCard .el-progress__text {
  display: none;
}

.OptionStrategyCard .vuejs-countdown .digit {
  font-size: 28px;
}

.OptionStrategyCard .el-checkbox__inner {
  border-radius: 4px;
}

.el-popover {
  background-color: #fff !important;
  border: none !important;
}

@media screen and (max-width: 1283px) {
  .OptionStrategyCard .selectedStrategyCard {
    .strategy-graph-section {
      width: 99%;
      margin: 0 auto;
      // background-color: #ffff;
    }

    .el-dialog {
      width: 90%;
      margin: 30px auto;
      border-radius: 10px;
    }

    .el-dialog__header {
      padding: 0;
    }
  }
}

@media screen and (max-width: 600px) {
  .OptionStrategyCard {
    .sentiment-card-dialog {
      .el-dialog {
        margin-top: 20px;
        width: 95%;

        .el-card__body {
          padding: 0;
        }
      }
    }

    // .performance-dialogue {
    //   height: 290px;
    // }
  }
}

@media screen and (max-width: 480px) {
  .OptionStrategyCard {
    .box-card {
      .el-card__body {
        padding: 12px;
      }
    }

    // .performance-dialogue {
    //   height: 315px;
    // }
  }
}

// .logic-popup {
//   .el-popover {
//     width: 80% !important;
//   }
// }
</style>
